<script setup lang="ts">
	import { computed, ref } from 'vue';
	import { useRoute } from 'vue-router';
	import { MonizzeLogo, MzBackground, MzButton, MzHeader, MzLayout } from '@monizze/monizze-components';
	import { PhList } from '@phosphor-icons/vue';
	import { useI18n } from 'vue-i18n';
	import { useMediaQuery } from '@vueuse/core';
	import UserSidebar from '@/components/UserSidebar.vue';
	import UserAccountMenu from '@/components/UserAccountMenu.vue';
	import { useAuthStore } from '@/stores/auth.ts';

	const { t } = useI18n();
	const route = useRoute();
	const authStore = useAuthStore();

	// Below `lg` the sidebar is a drawer the header burger opens.
	const sidebarOpen = ref(false);

	const showBackground = computed(() => route.name === 'user-dashboard' || route.name === 'partner');
	const isDesktop = useMediaQuery('(min-width: 64rem)');
</script>

<template>
	<mz-layout variant="sidebar" :ui="{ root: 'relative isolate', main: 'flex flex-col overflow-x-clip p-0 lg:p-0' }">
		<template #header>
			<mz-header variant="pill">
				<template #left>
					<div class="flex items-center gap-2">
						<mz-button :icon="PhList" variant="minimal" :aria-label="t('user.sidebar.open_menu')" @click="sidebarOpen = true" />
						<router-link to="/user/dashboard" class="flex items-center">
							<img v-if="authStore.isLux" src="/UpLux.svg" alt="" class="h-6 w-auto" />
							<monizze-logo v-else variant="icon" class="h-6 w-auto" />
						</router-link>
					</div>
				</template>
				<template #right>
					<user-account-menu icon-only side="bottom" />
				</template>
			</mz-header>
		</template>

		<template #sidebar>
			<user-sidebar v-model:open="sidebarOpen" />
		</template>

		<mz-background
			v-if="showBackground"
			:variant="authStore.isLux ? 'lux' : 'brand'"
			:size="isDesktop ? 'narrow' : 'small'"
			class="absolute inset-x-0 top-0 -z-10 aspect-square lg:aspect-auto lg:h-[450px]"
		/>
		<div :class="['max-w-[1200px] mx-auto w-full flex-1 flex flex-col pt-8', showBackground ? 'sm:px-6' : 'px-3 sm:px-6 pb-12']">
			<router-view />
		</div>
	</mz-layout>
</template>
